<template>
	<div>
		<div style="background:#00A6E5;display: flex;justify-content: center;">
			<div style="height: 80px;width: 60%;display: flex;align-items: center;justify-content: space-between;">
				<div style="display: flex;align-items: center;">
					<span style="font-size: 28px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 40px;margin-left: 14px;">牛人详情</span>
				</div>
				<div @click="goBack" style="width: 80px;height: 36px;border-radius: 4px;border: 1px solid #FFFFFF;display: flex;align-items: center;justify-content: space-around;cursor: pointer;">
					<span style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 22px;
				">返回</span>
				</div>
			</div>
		</div>
		<div style="display: flex;justify-content: center;" v-if="info">
			<div style="width: 60%;">
				<div class="top_block">
					<div class="top_top">
						<div class="img_left_block">
							<img :src="IMG_HOST+info.avatar" style="width: 60px;height: 60px;border-radius: 50%;" alt="">
							<div style="display: flex;flex-direction: column;margin-left: 20px;">
								<span style="font-size: 18px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #333333;line-height: 25px;">{{info.nick_name}} <span style="color: #00A6E5;font-weight: bold;font-size: 14px;">{{info.type ? info.type : ''}}</span></span>
								<span style="margin-top:6px;font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #999999;line-height: 18px;">简介：{{info.desc}}</span>
							</div>
						</div>
						<div>
							<button style="border:0px solid black;width: 130px;height: 48px;background: #00A6E5;border-radius: 4px;font-size: 18px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 25px;cursor: pointer;"
							 @click="gotoFollow(info)">跟单</button>
						</div>
					</div>
					<div style="display: flex;justify-content: space-between;padding-left: 110px;padding-right: 110px;">
						<div class="tips_item">
							<span class="tips_str">增长</span>
							<span class="tips_val">{{info.detail.growth_rate}}%</span>
						</div>
						<div class="tips_item">
							<span class="tips_str">跟随人数</span>
							<span class="tips_val">{{info.detail.follows}}</span>
						</div>
						<div class="tips_item">
							<span class="tips_str">余额</span>
							<span class="tips_val">{{parseFloat(info.detail.balance.toFixed(2))}}</span>
						</div>
						<div class="tips_item">
							<span class="tips_str">盈利</span>
							<span class="tips_val">{{parseFloat(info.detail.profit.toFixed(2))}}</span>
						</div>
						<div class="tips_item">
							<span class="tips_str">累计出金</span>
							<span class="tips_val">{{parseFloat((Math.abs(info.detail.withdraw)).toFixed(2))}}</span>
						</div>
						<div class="tips_item">
							<span class="tips_str">累计入金</span>
							<span class="tips_val">{{parseFloat(info.detail.deposit.toFixed(2))}}</span>
						</div>
						<div class="tips_item">
							<span class="tips_str">总隔夜费</span>
							<span class="tips_val">{{parseFloat(info.detail.swap.toFixed(2))}}</span>
						</div>
						<div class="tips_item">
							<span class="tips_str">总手续费</span>
							<span class="tips_val">{{parseFloat(info.detail.commission.toFixed(2))}}</span>
						</div>
					</div>
				</div>
				<div style="background: #FFFFFF;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);border-radius: 4px;margin-top: 30px;padding: 20px 30px 20px 30px;">
					<span class="title_bar">增长趋势</span>
					<div style="margin-top: 30px;" v-if="chartOptions">
						<highcharts :options="chartOptions"></highcharts>
					</div>
				</div>
			</div>
		</div>
		<div style="display: flex;justify-content: center;" v-if="info">
			<div style="width: 60%;">
				<div style="background: #FFFFFF;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);border-radius: 4px;margin-top: 30px;padding: 20px 30px 20px 30px;margin-bottom: 30px;">
					<div style="display: flex;justify-content: space-between;align-items: center;">
						<span class="title_bar" >历史记录</span>
						<div style="display: flex;align-items: center;cursor: pointer;" @click="gotoHistory(info.id)">
							<span style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #999999;line-height: 20px;">查看更多</span>
							<img src="../static/images/right_arrow_2.png" style="width: 8px;height: 8px;margin-left: 4px;" alt="">
						</div>
					</div>
					<div>
						<table border="1" class="table_all">
							<tr>
								<th>类型</th>
								<th>手数</th>
								<th>品种</th>
								<th>开仓时间</th>
								<th>开仓价格</th>
								<th>平仓时间</th>
								<th>平仓价格</th>
								<th>利润</th>
							</tr>
							<tr v-for="item in info.position">
								<td>{{item.type}}</td>
								<td>{{item.volumeopen}}</td>
								<td>{{item.symbol}}</td>
								<td>{{item.timeopen}}</td>
								<td>{{item.priceopen}}</td>
								<td>{{item.timeclose}}</td>
								<td>{{item.priceclose}}</td>
								<td>{{item.profit}}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		HOST,
		IMG_HOST
	} from '../Api.js'
	import {
		Chart
	} from 'highcharts-vue';
	export default {
		name: 'NiurenDetail',
		props: {
			msg: String
		},
		components: {
			highcharts: Chart
		},
		data() {
			return {
				IMG_HOST: IMG_HOST,
				id: null,
				info: null,
				chartOptions: null
			}
		},
		mounted() {
			if(this.$route.params.id){
				localStorage.setItem('NDID',this.$route.params.id);
				this.id = this.$route.params.id;
			}else{
				this.id = localStorage.getItem('NDID');
			}
			this.loadData();
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			dealTime(time){
				const date = new Date(time);
				const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
				const D = date.getDate() + ' ';
				return M + D;
			},
			loadData() {
				console.log('xxx')
				console.log(this.id)
				
				
				this.$layer.loading({content:'请求中'});
				fetch(HOST + 'biggun/detail/' + this.id, {
					method: 'GET',
					headers: {
						'content-type': 'application/json'
					}
				}).then(response => response.json()).then(res => {
					this.$layer.closeAll();
					if (res.errcode == '0000') {
						this.info = res.data;
						let xCat = [];
						let ser = [];
						for(let i = 0; i < res.data.detail.growth_rate_charts.length; i++){
							let t = res.data.detail.growth_rate_charts[i].time;
							t = this.dealTime(t);
							xCat.push(t);
							ser.push(res.data.detail.growth_rate_charts[i].chart_x*1);
						}
						this.chartOptions = {
							chart: {
								renderTo: 'container', //放置图表的容器  
								plotBackgroundColor: null,
								plotBorderWidth: null,
								zoomType: 'xy' //支持图表放大缩小的范围  
							},
							title: {
								text: ''
							},
							subtitle: {
								text: ''
							},
							credits: {
								enabled: false
							},
							xAxis: [{
								categories: xCat,
								tickLength: 0,
								labels: {
									//                      rotation: -45, //字体倾斜  
									align: 'center',
									style: {
										font: 'normal 10px PingFang SC'
									}
								}
							}],
							yAxis: [{ // Primary yAxis  
								title: {
									text: '',
									style: {
										color: '#7db5ed'
									}
								},
								labels: {
									nabled: false,
									formatter: function() {
										return this.value + "%";
									}
								}
							}],
							tooltip: {
								shared: true, //公用一个提示框  
								borderColor: '#8bbcee',
								formatter: function() {
									return this.x + "<br>" +
										"<span style='color:#4572A7'>增长率：" + this.points[0].y + " %</span><br>"
								}
							},
							plotOptions: {
								series: {
									marker: {
										enabled: false
									}
								},
							},
							//图例样式设置  
							legend: {
								enabled: false
							},
							series: [{
								name: '增长率',
								color: '#7db5ed',
								type: 'spline',
								yAxis: 0,
								data: ser,
								tooltip: {
									valueSuffix: '%'
								}
							}],
						}
					}
				})
			},
			gotoHistory(e) {
				this.$router.push({name:'History',params:{id:e}});
			},
			gotoFollow(data) {
				this.$router.push({name:'Follow',params:{data:data}})
			}
		}
	}
</script>

<style scoped>
	.top_block {
		height: 200px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
		border-radius: 4px;
		margin-top: 30px;
	}

	.img_left_block {
		display: flex;
		align-items: center;
	}

	.top_top {
		display: flex;
		justify-content: space-between;
		padding: 20px 30px 40px 30px;
	}

	.tips_item {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.tips_str {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 18px;
	}

	.tips_val {
		font-size: 16px;
		font-family: Helvetica;
		color: #333333;
		line-height: 19px;
		margin-top: 6px;
	}

	.title_bar {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}

	.table_all {
		width: 100%;
		border: 1px solid #EDEFF1;
		border-collapse: collapse;
		border-spacing: 0px;
		margin-top: 20px;
	}

	.table_all th {
		background: #F1F5F7;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 48px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;

	}

	.table_all td {
		background: #FFFFFF;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 54px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;
	}
</style>
